import { create } from 'zustand';

/**
 * Notification Store
 * Manages received alert notifications for display
 */
export const useNotificationStore = create((set, get) => ({
  // State
  notifications: [], // List of received notifications
  unreadCount: 0,
  isPushEnabled: false,
  // The user's persisted "Real-time mobile & browser alerts" preference
  // (Settings > Notifications, currentSettings.pushEnabled server-side) —
  // distinct from isPushEnabled above, which just tracks whether the browser
  // granted Notification permission. Defaults to true to match the backend
  // default until the real value loads.
  pushPreferenceEnabled: true,

  // Actions
  addNotification: (notification) => {
    set((state) => {
      // Prevent duplicates
      const exists = state.notifications.some(n => n.id === notification.id);
      if (exists) return state;

      const updated = [notification, ...state.notifications].slice(0, 50); // Keep last 50
      const unreadCount = updated.filter(n => !n.read).length;

      return {
        notifications: updated,
        unreadCount,
      };
    });
  },

  removeNotification: (notificationId) => {
    set((state) => {
      const updated = state.notifications.filter(n => n.id !== notificationId);
      const unreadCount = updated.filter(n => !n.read).length;
      return { notifications: updated, unreadCount };
    });
  },

  markAsRead: (notificationId) => {
    set((state) => {
      const updated = state.notifications.map(n =>
        n.id === notificationId ? { ...n, read: true } : n
      );
      const unreadCount = updated.filter(n => !n.read).length;
      return { notifications: updated, unreadCount };
    });
  },

  markAllAsRead: () => {
    set((state) => {
      const updated = state.notifications.map(n => ({ ...n, read: true }));
      return { notifications: updated, unreadCount: 0 };
    });
  },

  clearNotifications: () => {
    set({ notifications: [], unreadCount: 0 });
  },

  setPushEnabled: (enabled) => {
    set({ isPushEnabled: enabled });
  },

  setPushPreferenceEnabled: (enabled) => {
    set({ pushPreferenceEnabled: enabled });
  },
}));
